import React, { useState } from 'react'
import YouTube, { YouTubeProps } from 'react-youtube'
export const YoutubeVideo = ({
  videoId,
  onClick,
}: {
  videoId: string
  onClick: () => void
}) => {
  const [duration, setDuration] = useState<number | null>(null)

  const onReady: YouTubeProps['onReady'] = (event) => {
    const player = event.target

    // API가 준비된 후 duration을 가져옴 (초 단위)
    const durationSeconds = player.getDuration()
    setDuration(durationSeconds)
  }

  function formatSecondsToTimeString(seconds: number): string {
    const min = Math.floor(seconds / 60)
    const sec = Math.floor(seconds % 60)
    const paddedMin = String(min).padStart(2, '0')
    const paddedSec = String(sec).padStart(2, '0')
    return `${paddedMin}:${paddedSec}`
  }

  return (
    <div
      className="flex flex-col items-center cursor-pointer "
      onClick={onClick}
    >
      <YouTube
        videoId={videoId}
        opts={{
          width: '85',
          height: '64',
        }}
        onReady={onReady}
      />
      <span>{duration !== null && formatSecondsToTimeString(duration)}</span>
    </div>
  )
}
